import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_2 = { class: "inline-flex q-mb-xs" }
const _hoisted_3 = { class: "move-row" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  class: /*@__PURE__*/_normalizeClass(['move-row'])
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "move-row__tail"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "positions-toggle__label" }
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_app_tooltip = _resolveComponent("app-tooltip")!
  const _component_position_row = _resolveComponent("position-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          innerHTML: _ctx.moveTypeName(_ctx.el.MovementType)
        }, null, 8, _hoisted_4),
        (!_ctx.hideInfoBtn && _ctx.el.Id > 0)
          ? (_openBlock(), _createBlock(_component_app_tooltip, {
              key: 0,
              text: _ctx.$t('info'),
              style: { height: '18px' }
            }, {
              activator: _withCtx(() => [
                _createVNode(_component_app_icon, {
                  class: "move-row__info q-mr-xs",
                  name: "info-circle-outline",
                  width: "18px",
                  color: "#979797",
                  "hover-color": "#499259",
                  cursor: "pointer",
                  onClick: _ctx.openInfoDialog
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["text"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayLayout.head, (part, pidx) => {
              return (_openBlock(), _createElementBlock("span", {
                key: 'mv_part_' + pidx,
                class: "q-mr-xs",
                innerHTML: part
              }, null, 8, _hoisted_6))
            }), 128)),
            (_ctx.showPositionsToggle)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  (_ctx.displayLayout.tail)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        innerHTML: _ctx.displayLayout.tail
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    class: "positions-toggle",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('toggle-positions')), ["stop"]))
                  }, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.positionsCountLabel), 1),
                    (_ctx.positionsExpanded)
                      ? (_openBlock(), _createBlock(_component_app_icon, {
                          key: 0,
                          class: "positions-toggle__chevron",
                          name: "chevron-down",
                          width: "10px",
                          color: "#979797"
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (!_ctx.hideRemoveBtn)
        ? (_openBlock(), _createBlock(_component_app_tooltip, {
            key: 0,
            text: _ctx.$t('remove'),
            style: { height: '16px' }
          }, {
            activator: _withCtx(() => [
              _createVNode(_component_app_icon, {
                class: "ml-1 move-row__remove",
                name: "close",
                width: "16px",
                color: "#979797",
                "hover-color": "#616161",
                cursor: "pointer",
                onClick: _withModifiers(_ctx.detach, ["stop"])
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["text"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showPositions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.el.Items, (pos, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "row no-wrap items-baseline",
              key: 'item_pos_' + idx
            }, [
              _createTextVNode(_toDisplayString(idx + 1) + ")  ", 1),
              _createVNode(_component_position_row, {
                id: pos.Id,
                el: _ctx.getPositionFromNameInstance(pos),
                "hide-info-btn": true
              }, null, 8, ["id", "el"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}